import { useMocks } from '../../shared/env';
import type { HealthcareRatesGateway } from './HealthcareRatesGateway';
import { HttpHealthcareRatesGateway } from './HttpHealthcareRatesGateway';
import { MockHealthcareRatesGateway } from './MockHealthcareRatesGateway';

export const healthcareRatesGateway: HealthcareRatesGateway = useMocks ? new MockHealthcareRatesGateway() : new HttpHealthcareRatesGateway();
export type { HealthcareRatesGateway } from './HealthcareRatesGateway';
